import { AsyncPipe, NgClass, NgFor, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import { DropdownInputComponent } from '../../../form-components/dropdown-input/dropdown-input.component';

@Component({
  selector: 'app-table-header-dropdown-input',
  templateUrl: '../../../../ui/form-components/dropdown-input/dropdown-input.component.html',
  styleUrls: ['./table-header-dropdown-input.component.scss', '../table-column-inputs.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TableHeaderDropdownInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: true,
  imports: [
    AsyncPipe,
    NgClass,
    NgFor,
    NgIf,
    NgSwitch,
    NgSwitchCase,
    NgSwitchDefault,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    NgbDropdownItem
  ]
})
export class TableHeaderDropdownInputComponent extends DropdownInputComponent {
  @Input() placeholder: string = $localize`Select`;
  @Input() clearable: boolean = true;
}
